import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';

// Layouts
import PublicLayout from './layouts/PublicLayout';
import MemberLayout from './layouts/MemberLayout';
import AdminLayout from './layouts/AdminLayout';

// Public Pages
import HomePage from './pages/public/HomePage';
import MeetingsPage from './pages/public/MeetingsPage';
import FreemasonryPage from './pages/public/FreemasonryPage';
import UniversityLodgeSchemePage from './pages/public/UniversityLodgeSchemePage';
import QualificationsPage from './pages/public/QualificationsPage';
import MoreInformationPage from './pages/public/MoreInformationPage';
import NewsPage from './pages/public/NewsPage';
import LoginPage from './pages/public/LoginPage';
import ContactPage from './pages/public/ContactPage';

// Member Pages
import MemberDashboard from './pages/member/MemberDashboard';
import LearningPage from './pages/member/LearningPage';
import CollectionsPage from './pages/member/CollectionsPage';
import MeetingMinutesPage from './pages/member/MeetingMinutesPage';
import DegreeWorkPage from './pages/member/DegreeWorkPage';
import ProfilePage from './pages/member/ProfilePage';
import MemberSupportPage from './pages/member/MemberSupportPage';

// Admin Pages
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminUsersPage from './pages/admin/AdminUsersPage';
import AdminSupportPage from './pages/admin/AdminSupportPage';
import AdminMinutesPage from './pages/admin/AdminMinutesPage';
import AdminDegreeWorkPage from './pages/admin/AdminDegreeWorkPage';
import AdminLearningPage from './pages/admin/AdminLearningPage';

// Public Route Wrapper
const PublicPage = ({ children }) => (
  <PublicLayout>{children}</PublicLayout>
);

// Member Route Wrapper
const MemberPage = ({ children }) => (
  <MemberLayout>{children}</MemberLayout>
);

// Admin Route Wrapper
const AdminPage = ({ children }) => (
  <AdminLayout>{children}</AdminLayout>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<PublicPage><HomePage /></PublicPage>} />
          <Route path="/meetings" element={<PublicPage><MeetingsPage /></PublicPage>} />
          <Route path="/freemasonry" element={<PublicPage><FreemasonryPage /></PublicPage>} />
          <Route path="/university-lodge-scheme" element={<PublicPage><UniversityLodgeSchemePage /></PublicPage>} />
          <Route path="/university-lodge-scheme/qualifications" element={<PublicPage><QualificationsPage /></PublicPage>} />
          <Route path="/more-information" element={<PublicPage><MoreInformationPage /></PublicPage>} />
          <Route path="/news" element={<PublicPage><NewsPage /></PublicPage>} />
          <Route path="/login" element={<PublicPage><LoginPage /></PublicPage>} />
          <Route path="/contact" element={<PublicPage><ContactPage /></PublicPage>} />

          {/* Member Routes */}
          <Route path="/members" element={<MemberPage><MemberDashboard /></MemberPage>} />
          <Route path="/members/learning" element={<MemberPage><LearningPage /></MemberPage>} />
          <Route path="/members/collections" element={<MemberPage><CollectionsPage /></MemberPage>} />
          <Route path="/members/minutes" element={<MemberPage><MeetingMinutesPage /></MemberPage>} />
          <Route path="/members/degree-work" element={<MemberPage><DegreeWorkPage /></MemberPage>} />
          <Route path="/members/profile" element={<MemberPage><ProfilePage /></MemberPage>} />
          <Route path="/members/support" element={<MemberPage><MemberSupportPage /></MemberPage>} />

          {/* Admin Routes */}
          <Route path="/admin" element={<AdminPage><AdminDashboard /></AdminPage>} />
          <Route path="/admin/users" element={<AdminPage><AdminUsersPage /></AdminPage>} />
          <Route path="/admin/support" element={<AdminPage><AdminSupportPage /></AdminPage>} />
          <Route path="/admin/minutes" element={<AdminPage><AdminMinutesPage /></AdminPage>} />
          <Route path="/admin/degree-work" element={<AdminPage><AdminDegreeWorkPage /></AdminPage>} />
          <Route path="/admin/learning" element={<AdminPage><AdminLearningPage /></AdminPage>} />

          {/* Catch-all redirect */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </AuthProvider>
  );
}

export default App;
